"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.useStateWithSessionStorage = exports.useStateWithLocalStorage = void 0;

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var useStateWithLocalStorage = exports.useStateWithLocalStorage = function (a) {
  var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "",
      c = _react2.default.useState(localStorage.getItem(a) || b),
      d = (0, _slicedToArray3.default)(c, 2),
      e = d[0],
      f = d[1];

  return _react2.default.useEffect(function () {
    localStorage.setItem(a, e);
  }, [e]), [e, f];
},
    getItem = function getItem(a, b) {
  return b;
},
    setItem = function setItem() {};

if ("undefined" != typeof window) var _sessionStorage = sessionStorage,
    _getItem = _sessionStorage.getItem,
    _setItem = _sessionStorage.setItem;

var useStateWithSessionStorage = exports.useStateWithSessionStorage = function (a) {
  var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "",
      c = _react2.default.useState(getItem(a) || b),
      d = (0, _slicedToArray3.default)(c, 2),
      e = d[0],
      f = d[1];

  return _react2.default.useEffect(function () {
    setItem(a, e);
  }, [e]), [e, f];
};